import {type MouseEvent, useMemo} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {PercentIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useElementWasVisible} from "@pg-mono/hooks";
import {upperFirst} from "@pg-mono/nodash";
import {housingEstate, promotionVerbPluralize} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {ColumnListItem} from "../../../../atoms/ColumnListItem";
import {OfferBoxBasePanda} from "../../../../atoms/OfferBoxBase";
import {getRegionPromotionLink} from "../../../../promotion/helpers/get_region_promotion_link";
import {useAmplitudePromotionViewportTracking} from "../../../../promotion/hooks/use_amplitude_promotion_viewport_tracking";
import {IAmplitudeItemListContext} from "../../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {getAmplitudeOfferListingPromotionCardTrackingContext} from "../../helpers/get_amplitude_offer_listing_promotion_card_tracking_context";
import {disableDynamicPositionProps, IDynamicPositionProps} from "../../hooks/use_list_dynamic_positions";
import {hitPromotionTileEvent} from "../../tracking/hit_promotion_tile_event";

interface IProps {
    selectedRegion: ISelectedRegion[];
    getDynamicPositionProps: () => IDynamicPositionProps;
    listingPage: number;
    tilePosition: number;
    amplitudeItemListContext?: IAmplitudeItemListContext;
}

export const PromotionsListingTile = (props: IProps) => {
    const {selectedRegion, getDynamicPositionProps, listingPage, tilePosition, amplitudeItemListContext} = props;

    const {isMobile} = useUserDevice();

    const promotionOffersCount = selectedRegion.length === 1 && selectedRegion[0].stats ? selectedRegion[0].stats.promotions_count_total : 0;
    const regionName = selectedRegion[0]?.name_declension_where ? upperFirst(selectedRegion[0].name_declension_where) : "W tej lokalizacji";
    const promotionCardContent = `${regionName} ${promotionVerbPluralize(promotionOffersCount)} ${promotionOffersCount} ${housingEstate.nominative(
        promotionOffersCount
    )} z promocjami`;

    const promotionTileDataId = `promotion-tile-${listingPage}-${tilePosition}`;
    const promotionListingLink = getRegionPromotionLink(selectedRegion?.[0]?.slug, selectedRegion?.[0]?.parent?.slug, selectedRegion?.[0]?.stats);
    const amplitudeTrackingContext = useMemo(
        () => getAmplitudeOfferListingPromotionCardTrackingContext(promotionCardContent, amplitudeItemListContext),
        [amplitudeItemListContext, promotionCardContent]
    );

    useElementWasVisible({
        ids: [promotionTileDataId],
        onElementVisible: () => {
            hitPromotionTileEvent("view", eventParams);
        },
        once: true,
        disabled: promotionOffersCount === 0
    });

    useAmplitudePromotionViewportTracking({
        trackingContext: amplitudeTrackingContext,
        elementId: promotionTileDataId,
        disabled: promotionOffersCount === 0 || !promotionListingLink
    });

    if (promotionOffersCount === 0 || !promotionListingLink) return null;

    const eventParams = {
        redirectPath: promotionListingLink,
        tilePosition,
        listingPage,
        promotionOffersCount
    };

    const handleTileClick = () => {
        hitPromotionTileEvent("click", {...eventParams, customLabel: "tile"});
    };

    const handleCtaClick = (event: MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        hitPromotionTileEvent("click", {...eventParams, customLabel: "cta"});
    };

    return (
        <ColumnListItem dynamicProps={isMobile ? disableDynamicPositionProps() : getDynamicPositionProps()} className="rp-filters-tile">
            <OfferBoxBasePanda>
                <a data-id={promotionTileDataId} href={promotionListingLink} className={wrapper} onClick={handleTileClick}>
                    <div className={content}>
                        <PercentIcon size="11.2" wrapperSize="11.2" />

                        <Text variant="headline_3" as="p" align="center" className={text}>
                            {promotionCardContent}
                        </Text>
                    </div>

                    <Button as="div" variant="filled_secondary" fullWidth onClick={handleCtaClick}>
                        Sprawdź oferty promocyjne
                    </Button>
                </a>
            </OfferBoxBasePanda>
        </ColumnListItem>
    );
};

const wrapper = css({
    width: "100%",
    height: "100%",
    backgroundColor: "var(--colors-highlight)",
    padding: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: "466px",
    color: "inherit",
    textDecoration: "none",
    borderRadius: "var(--radii-2)",

    "&, &:link, &:visited, &:hover, &:active, &:focus": {
        color: "inherit",
        textDecoration: "none"
    }
});

const content = css({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
});

const text = css({
    maxWidth: "277px",
    mt: "60px"
});
import {type MouseEvent, useMemo} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {PercentIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useElementWasVisible} from "@pg-mono/hooks";
import {upperFirst} from "@pg-mono/nodash";
import {housingEstate, promotionVerbPluralize} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {ColumnListItem} from "../../../../atoms/ColumnListItem";
import {OfferBoxBasePanda} from "../../../../atoms/OfferBoxBase";
import {getRegionPromotionLink} from "../../../../promotion/helpers/get_region_promotion_link";
import {useAmplitudePromotionViewportTracking} from "../../../../promotion/hooks/use_amplitude_promotion_viewport_tracking";
import {IAmplitudeItemListContext} from "../../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {getAmplitudeOfferListingPromotionCardTrackingContext} from "../../helpers/get_amplitude_offer_listing_promotion_card_tracking_context";
import {disableDynamicPositionProps, IDynamicPositionProps} from "../../hooks/use_list_dynamic_positions";
import {hitPromotionTileEvent} from "../../tracking/hit_promotion_tile_event";

interface IProps {
    selectedRegion: ISelectedRegion[];
    getDynamicPositionProps: () => IDynamicPositionProps;
    listingPage: number;
    tilePosition: number;
    amplitudeItemListContext?: IAmplitudeItemListContext;
}

export const PromotionsListingTile = (props: IProps) => {
    const {selectedRegion, getDynamicPositionProps, listingPage, tilePosition, amplitudeItemListContext} = props;

    const {isMobile} = useUserDevice();

    const promotionOffersCount = selectedRegion.length === 1 && selectedRegion[0].stats ? selectedRegion[0].stats.promotions_count_total : 0;
    const regionName = selectedRegion[0]?.name_declension_where ? upperFirst(selectedRegion[0].name_declension_where) : "W tej lokalizacji";
    const promotionCardContent = `${regionName} ${promotionVerbPluralize(promotionOffersCount)} ${promotionOffersCount} ${housingEstate.nominative(
        promotionOffersCount
    )} z promocjami`;

    const promotionTileDataId = `promotion-tile-${listingPage}-${tilePosition}`;
    const promotionListingLink = getRegionPromotionLink(selectedRegion?.[0]?.slug, selectedRegion?.[0]?.parent?.slug, selectedRegion?.[0]?.stats);
    const amplitudeTrackingContext = useMemo(
        () => getAmplitudeOfferListingPromotionCardTrackingContext(promotionCardContent, amplitudeItemListContext),
        [amplitudeItemListContext, promotionCardContent]
    );

    useElementWasVisible({
        ids: [promotionTileDataId],
        onElementVisible: () => {
            hitPromotionTileEvent("view", eventParams);
        },
        once: true,
        disabled: promotionOffersCount === 0
    });

    useAmplitudePromotionViewportTracking({
        trackingContext: amplitudeTrackingContext,
        elementId: promotionTileDataId,
        disabled: promotionOffersCount === 0 || !promotionListingLink
    });

    if (promotionOffersCount === 0 || !promotionListingLink) return null;

    const eventParams = {
        redirectPath: promotionListingLink,
        tilePosition,
        listingPage,
        promotionOffersCount
    };

    const handleTileClick = () => {
        hitPromotionTileEvent("click", {...eventParams, customLabel: "tile"});
    };

    const handleCtaClick = (event: MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        hitPromotionTileEvent("click", {...eventParams, customLabel: "cta"});
    };

    return (
        <ColumnListItem dynamicProps={isMobile ? disableDynamicPositionProps() : getDynamicPositionProps()} className="rp-filters-tile">
            <OfferBoxBasePanda>
                <a data-id={promotionTileDataId} href={promotionListingLink} className={wrapper} onClick={handleTileClick}>
                    <div className={content}>
                        <PercentIcon size="11.2" wrapperSize="11.2" />

                        <Text variant="headline_3" as="p" align="center" className={text}>
                            {promotionCardContent}
                        </Text>
                    </div>

                    <Button as="div" variant="filled_secondary" fullWidth onClick={handleCtaClick}>
                        Sprawdź oferty promocyjne
                    </Button>
                </a>
            </OfferBoxBasePanda>
        </ColumnListItem>
    );
};

const wrapper = css({
    width: "100%",
    height: "100%",
    backgroundColor: "var(--colors-highlight)",
    padding: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: "466px",
    color: "inherit",
    textDecoration: "none",
    borderRadius: "var(--radii-2)",

    "&, &:link, &:visited, &:hover, &:active, &:focus": {
        color: "inherit",
        textDecoration: "none"
    }
});

const content = css({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
});

const text = css({
    maxWidth: "277px",
    mt: "60px"
});
